export function parallaxImageGallery() {
    let slowElements;
    let mediumElements;
    let fastElements;
    let galleryContainer;
    let isInViewport = false;
    let scrollOffset = 0; // Track scroll position when gallery enters viewport
    
    const slowSelector = '.parallax-slow';
    const mediumSelector = '.parallax-medium';
    const fastSelector = '.parallax-fast';
    const gallerySelector = '.image-gallery'; // Add this class to your gallery container
    
    const handleScroll = function() {
        if (!isInViewport) return; // Only apply parallax when in viewport
        
        const scrolled = window.pageYOffset - scrollOffset;
        const rate = scrolled * 0.5;
        const isMobile = window.innerWidth <= 768;
        
        slowElements.forEach((element) => {
            const movement = rate * (isMobile ? 0.06 : 0.12);
            element.style.transform = `translateY(${movement}px)`;
        });
        
        mediumElements.forEach((element) => {
            const movement = rate * (isMobile ? 0.1 : 0.2);
            element.style.transform = `translateY(${movement}px)`;
        });
        
        fastElements.forEach((element) => {
            const movement = rate * (isMobile ? 0.05 : 0.1);
            element.style.transform = `translateY(${movement}px)`;
        });
    };
    
    const resetTransforms = function() {
        [...slowElements, ...mediumElements, ...fastElements].forEach(element => {
            element.style.transform = 'translateY(0px)';
        });
    };
    
    const observerCallback = function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                isInViewport = true;
                scrollOffset = window.pageYOffset; // Reset offset when entering viewport
                handleScroll(); // Apply initial transform
            } else {
                isInViewport = false;
                resetTransforms(); // Reset transforms when leaving viewport
            }
        });
    };
    
    const init = function() {
        slowElements = Array.from(document.querySelectorAll(slowSelector));
        mediumElements = Array.from(document.querySelectorAll(mediumSelector));
        fastElements = Array.from(document.querySelectorAll(fastSelector));
        
        // Find the gallery container
        galleryContainer = document.querySelector(gallerySelector);
        
        if (!galleryContainer) {
            return;
        }
        
        // Create intersection observer
        const observer = new IntersectionObserver(observerCallback, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Trigger when 10% of the gallery is visible
        });
        
        observer.observe(galleryContainer);
        
        // Add scroll listener
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // Initial reset to ensure no transforms are applied initially
        resetTransforms();
    };
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    window.addEventListener('load', () => {
        setTimeout(init, 1000);
    });
}

parallaxImageGallery();